/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FederalCourtDistrictEnum = {
    DMeDistrictOfMaine1stCircuit: 'D. Me. - District of Maine (1st Circuit)',
    DMassDistrictOfMassachusetts1stCircuit: 'D. Mass. - District of Massachusetts (1st Circuit)',
    DNHDistrictOfNewHampshire1stCircuit: 'D.N.H. - District of New Hampshire (1st Circuit)',
    DRIDistrictOfRhodeIsland1stCircuit: 'D.R.I. - District of Rhode Island (1st Circuit)',
    DPRDistrictOfPuertoRico1stCircuit: 'D.P.R. - District of Puerto Rico (1st Circuit)',
    DConnDistrictOfConnecticut2ndCircuit: 'D. Conn. - District of Connecticut (2nd Circuit)',
    NDNYNorthernDistrictOfNewYork2ndCircuit: 'N.D.N.Y. - Northern District of New York (2nd Circuit)',
    SDNYSouthernDistrictOfNewYork2ndCircuit: 'S.D.N.Y. - Southern District of New York (2nd Circuit)',
    EDNYEasternDistrictOfNewYork2ndCircuit: 'E.D.N.Y. - Eastern District of New York (2nd Circuit)',
    WDNYWesternDistrictOfNewYork2ndCircuit: 'W.D.N.Y. - Western District of New York (2nd Circuit)',
    DVtDistrictOfVermont2ndCircuit: 'D. Vt. - District of Vermont (2nd Circuit)',
    DDelDistrictOfDelaware3rdCircuit: 'D. Del. - District of Delaware (3rd Circuit)',
    DNJDistrictOfNewJersey3rdCircuit: 'D.N.J. - District of New Jersey (3rd Circuit)',
    EDPaEasternDistrictOfPennsylvania3rdCircuit: 'E.D. Pa. - Eastern District of Pennsylvania (3rd Circuit)',
    MDPaMiddleDistrictOfPennsylvania3rdCircuit: 'M.D. Pa. - Middle District of Pennsylvania (3rd Circuit)',
    WDPaWesternDistrictOfPennsylvania3rdCircuit: 'W.D. Pa. - Western District of Pennsylvania (3rd Circuit)',
    DVIDistrictOfTheVirginIslands3rdCircuit: 'D.V.I. - District of the Virgin Islands (3rd Circuit)',
    DMdDistrictOfMaryland4thCircuit: 'D. Md. - District of Maryland (4th Circuit)',
    EDNCEasternDistrictOfNorthCarolina4thCircuit: 'E.D.N.C. - Eastern District of North Carolina (4th Circuit)',
    MDNCMiddleDistrictOfNorthCarolina4thCircuit: 'M.D.N.C. - Middle District of North Carolina (4th Circuit)',
    WDNCWesternDistrictOfNorthCarolina4thCircuit: 'W.D.N.C. - Western District of North Carolina (4th Circuit)',
    DSCDistrictOfSouthCarolina4thCircuit: 'D.S.C. - District of South Carolina (4th Circuit)',
    EDVaEasternDistrictOfVirginia4thCircuit: 'E.D. Va. - Eastern District of Virginia (4th Circuit)',
    WDVaWesternDistrictOfVirginia4thCircuit: 'W.D. Va. - Western District of Virginia (4th Circuit)',
    NDWVaNorthernDistrictOfWestVirginia4thCircuit: 'N.D.W. Va. - Northern District of West Virginia (4th Circuit)',
    SDWVaSouthernDistrictOfWestVirginia4thCircuit: 'S.D.W. Va. - Southern District of West Virginia (4th Circuit)',
    EDLaEasternDistrictOfLouisiana5thCircuit: 'E.D. La. - Eastern District of Louisiana (5th Circuit)',
    MDLaMiddleDistrictOfLouisiana5thCircuit: 'M.D. La. - Middle District of Louisiana (5th Circuit)',
    WDLaWesternDistrictOfLouisiana5thCircuit: 'W.D. La. - Western District of Louisiana (5th Circuit)',
    NDMissNorthernDistrictOfMississippi5thCircuit: 'N.D. Miss. - Northern District of Mississippi (5th Circuit)',
    SDMissSouthernDistrictOfMississippi5thCircuit: 'S.D. Miss. - Southern District of Mississippi (5th Circuit)',
    EDTexEasternDistrictOfTexas5thCircuit: 'E.D. Tex. - Eastern District of Texas (5th Circuit)',
    NDTexNorthernDistrictOfTexas5thCircuit: 'N.D. Tex. - Northern District of Texas (5th Circuit)',
    SDTexSouthernDistrictOfTexas5thCircuit: 'S.D. Tex. - Southern District of Texas (5th Circuit)',
    WDTexWesternDistrictOfTexas5thCircuit: 'W.D. Tex. - Western District of Texas (5th Circuit)',
    EDKyEasternDistrictOfKentucky6thCircuit: 'E.D. Ky. - Eastern District of Kentucky (6th Circuit)',
    WDKyWesternDistrictOfKentucky6thCircuit: 'W.D. Ky. - Western District of Kentucky (6th Circuit)',
    EDMichEasternDistrictOfMichigan6thCircuit: 'E.D. Mich. - Eastern District of Michigan (6th Circuit)',
    WDMichWesternDistrictOfMichigan6thCircuit: 'W.D. Mich. - Western District of Michigan (6th Circuit)',
    NDOhioNorthernDistrictOfOhio6thCircuit: 'N.D. Ohio - Northern District of Ohio (6th Circuit)',
    SDOhioSouthernDistrictOfOhio6thCircuit: 'S.D. Ohio - Southern District of Ohio (6th Circuit)',
    EDTennEasternDistrictOfTennessee6thCircuit: 'E.D. Tenn. - Eastern District of Tennessee (6th Circuit)',
    MDTennMiddleDistrictOfTennessee6thCircuit: 'M.D. Tenn. - Middle District of Tennessee (6th Circuit)',
    WDTennWesternDistrictOfTennessee6thCircuit: 'W.D. Tenn. - Western District of Tennessee (6th Circuit)',
    CDIllCentralDistrictOfIllinois7thCircuit: 'C.D. Ill. - Central District of Illinois (7th Circuit)',
    NDIllNorthernDistrictOfIllinois7thCircuit: 'N.D. Ill. - Northern District of Illinois (7th Circuit)',
    SDIllSouthernDistrictOfIllinois7thCircuit: 'S.D. Ill. - Southern District of Illinois (7th Circuit)',
    NDIndNorthernDistrictOfIndiana7thCircuit: 'N.D. Ind. - Northern District of Indiana (7th Circuit)',
    SDIndSouthernDistrictOfIndiana7thCircuit: 'S.D. Ind. - Southern District of Indiana (7th Circuit)',
    EDWisEasternDistrictOfWisconsin7thCircuit: 'E.D. Wis. - Eastern District of Wisconsin (7th Circuit)',
    WDWisWesternDistrictOfWisconsin7thCircuit: 'W.D. Wis. - Western District of Wisconsin (7th Circuit)',
    EDArkEasternDistrictOfArkansas8thCircuit: 'E.D. Ark. - Eastern District of Arkansas (8th Circuit)',
    WDArkWesternDistrictOfArkansas8thCircuit: 'W.D. Ark. - Western District of Arkansas (8th Circuit)',
    NDIowaNorthernDistrictOfIowa8thCircuit: 'N.D. Iowa - Northern District of Iowa (8th Circuit)',
    SDIowaSouthernDistrictOfIowa8thCircuit: 'S.D. Iowa - Southern District of Iowa (8th Circuit)',
    DMinnDistrictOfMinnesota8thCircuit: 'D. Minn. - District of Minnesota (8th Circuit)',
    EDMoEasternDistrictOfMissouri8thCircuit: 'E.D. Mo. - Eastern District of Missouri (8th Circuit)',
    WDMoWesternDistrictOfMissouri8thCircuit: 'W.D. Mo. - Western District of Missouri (8th Circuit)',
    DNebDistrictOfNebraska8thCircuit: 'D. Neb. - District of Nebraska (8th Circuit)',
    DNDDistrictOfNorthDakota8thCircuit: 'D. N.D. - District of North Dakota (8th Circuit)',
    DSDDistrictOfSouthDakota8thCircuit: 'D. S.D. - District of South Dakota (8th Circuit)',
    DAlaskaDistrictOfAlaska9thCircuit: 'D. Alaska - District of Alaska (9th Circuit)',
    DArizDistrictOfArizona9thCircuit: 'D. Ariz. - District of Arizona (9th Circuit)',
    CDCalCentralDistrictOfCalifornia9thCircuit: 'C.D. Cal. - Central District of California (9th Circuit)',
    EDCalEasternDistrictOfCalifornia9thCircuit: 'E.D. Cal. - Eastern District of California (9th Circuit)',
    NDCalNorthernDistrictOfCalifornia9thCircuit: 'N.D. Cal. - Northern District of California (9th Circuit)',
    SDCalSouthernDistrictOfCalifornia9thCircuit: 'S.D. Cal. - Southern District of California (9th Circuit)',
    DHawDistrictOfHawaii9thCircuit: 'D. Haw. - District of Hawaii (9th Circuit)',
    DIdahoDistrictOfIdaho9thCircuit: 'D. Idaho - District of Idaho (9th Circuit)',
    DMontDistrictOfMontana9thCircuit: 'D. Mont. - District of Montana (9th Circuit)',
    DNevDistrictOfNevada9thCircuit: 'D. Nev. - District of Nevada (9th Circuit)',
    DOrDistrictOfOregon9thCircuit: 'D. Or. - District of Oregon (9th Circuit)',
    EDWashEasternDistrictOfWashington9thCircuit: 'E.D. Wash. - Eastern District of Washington (9th Circuit)',
    WDWashWesternDistrictOfWashington9thCircuit: 'W.D. Wash. - Western District of Washington (9th Circuit)',
    DGuamDistrictOfGuam9thCircuit: 'D. Guam - District of Guam (9th Circuit)',
    DColoDistrictOfColorado10thCircuit: 'D. Colo. - District of Colorado (10th Circuit)',
    DKanDistrictOfKansas10thCircuit: 'D. Kan. - District of Kansas (10th Circuit)',
    DNMDistrictOfNewMexico10thCircuit: 'D.N.M. - District of New Mexico (10th Circuit)',
    EDOklaEasternDistrictOfOklahoma10thCircuit: 'E.D. Okla. - Eastern District of Oklahoma (10th Circuit)',
    NDOklaNorthernDistrictOfOklahoma10thCircuit: 'N.D. Okla. - Northern District of Oklahoma (10th Circuit)',
    WDOklaWesternDistrictOfOklahoma10thCircuit: 'W.D. Okla. - Western District of Oklahoma (10th Circuit)',
    DUtahDistrictOfUtah10thCircuit: 'D. Utah - District of Utah (10th Circuit)',
    DWyoDistrictOfWyoming10thCircuit: 'D. Wyo. - District of Wyoming (10th Circuit)',
    MDAlaMiddleDistrictOfAlabama11thCircuit: 'M.D. Ala. - Middle District of Alabama (11th Circuit)',
    NDAlaNorthernDistrictOfAlabama11thCircuit: 'N.D. Ala. - Northern District of Alabama (11th Circuit)',
    SDAlaSouthernDistrictOfAlabama11thCircuit: 'S.D. Ala. - Southern District of Alabama (11th Circuit)',
    MDFlaMiddleDistrictOfFlorida11thCircuit: 'M.D. Fla. - Middle District of Florida (11th Circuit)',
    NDFlaNorthernDistrictOfFlorida11thCircuit: 'N.D. Fla. - Northern District of Florida (11th Circuit)',
    SDFlaSouthernDistrictOfFlorida11thCircuit: 'S.D. Fla. - Southern District of Florida (11th Circuit)',
    MDGaMiddleDistrictOfGeorgia11thCircuit: 'M.D. Ga. - Middle District of Georgia (11th Circuit)',
    NDGaNorthernDistrictOfGeorgia11thCircuit: 'N.D. Ga. - Northern District of Georgia (11th Circuit)',
    SDGaSouthernDistrictOfGeorgia11thCircuit: 'S.D. Ga. - Southern District of Georgia (11th Circuit)',
    DDCDistrictOfColumbiaDCCircuit: 'D.D.C. - District of Columbia (D.C. Circuit)'
} as const;
export type FederalCourtDistrictEnum = typeof FederalCourtDistrictEnum[keyof typeof FederalCourtDistrictEnum];


export function instanceOfFederalCourtDistrictEnum(value: any): boolean {
    for (const key in FederalCourtDistrictEnum) {
        if (Object.prototype.hasOwnProperty.call(FederalCourtDistrictEnum, key)) {
            if (FederalCourtDistrictEnum[key as keyof typeof FederalCourtDistrictEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FederalCourtDistrictEnumFromJSON(json: any): FederalCourtDistrictEnum {
    return FederalCourtDistrictEnumFromJSONTyped(json, false);
}

export function FederalCourtDistrictEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): FederalCourtDistrictEnum {
    return json as FederalCourtDistrictEnum;
}

export function FederalCourtDistrictEnumToJSON(value?: FederalCourtDistrictEnum | null): any {
    return value as any;
}

export function FederalCourtDistrictEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): FederalCourtDistrictEnum {
    return value as FederalCourtDistrictEnum;
}

